import React from "react";
import PanelBody from "../../UI/Panel/PanelBody";
import PanelHead from "../../UI/Panel/PanelHead";
import {ManagePanelsTable} from "../../UI/Main/ManagePanelsTable";
import {ManagePeoplesTable} from "../../UI/Main/ManagePeoplesTable";

const ManagePeoples = () => {
    return (
        <div>
            <PanelHead title="Manage Services" />
            <PanelBody content={<ManagePeoplesTable />} />
        </div>
    );
};

export default ManagePeoples;
